import { Component, computed, EventEmitter, input, Input, Output } from '@angular/core';
import { dispoStatusColors } from '../color-pills-consts';
import { PillColorType } from '@eg/ui';
import { DispoOrderInfoModel, TransportCategoryTypeModel, TransportSectionTypeModel } from '@railmybox/api-dispo';

@Component({
  selector: 'rmb-dispo-order-chain',
  templateUrl: './dispo-order-chain.component.html',
  styleUrls: ['./dispo-order-chain.component.scss'],
  standalone: false,
})
export class DispoOrderChainComponent {
  @Input() reference?: string = '';

  readonly dispoOrder = input<DispoOrderInfoModel>();

  readonly category = computed(() => {
    const catString = this.dispoOrder()?.reference.charAt(1);
    switch (catString) {
      case 'I':
        return TransportCategoryTypeModel.Import;
      case 'E':
        return TransportCategoryTypeModel.Export;
      case 'D':
        return TransportCategoryTypeModel.Domestic;
      default:
        return undefined;
    }
  });
  readonly isRepositioning = computed(() => {
    return (
      (this.dispoOrder()?.transportSection === 'PRERUN' && this.category() === TransportCategoryTypeModel.Import) ||
      (this.dispoOrder()?.transportSection === 'POSTRUN' && this.category() === TransportCategoryTypeModel.Export)
    );
  });

  readonly fromAddress = computed(() => {
    const address = this.dispoOrder()?.addresses[0];
    return address.name2 || address.display;
  });

  readonly toAddress = computed(() => {
    const address = this.dispoOrder()?.addresses[this.dispoOrder()?.addresses.length - 1];
    return address.name2 || address.display;
  });

  readonly arrivalDate = computed(() => {
    const isRepositioning = this.isRepositioning();
    const addresses = this.dispoOrder()?.addresses.filter((p) => isRepositioning || p.type === 'LOCATION');
    if (this.dispoOrder()?.transportSection === 'PRERUN') {
      return addresses[this.category() === TransportCategoryTypeModel.Import ? addresses.length - 1 : 0]?.arrivedAt;
    }
    if (this.dispoOrder()?.transportSection === 'POSTRUN') {
      return addresses[this.category() === TransportCategoryTypeModel.Export ? addresses.length - 1 : 0]?.arrivedAt;
    }
    return null;
  });

  @Output() clicked = new EventEmitter<DispoOrderInfoModel>();

  dispoStatusColors: PillColorType = dispoStatusColors;

  goToOrder() {
    this.clicked.emit(this.dispoOrder());
  }

  protected readonly TransportSectionTypeModel = TransportSectionTypeModel;
}
